export default __webpack_public_path__ + "static/media/regex.fe79e416.png";